<template>
  <div class="gen-page">
    <!-- 左右布局 -->
    <div class="gen-layout">
      <!-- Sidebar (1) -->
      <aside class="gen-sidebar">
        <div class="sidebar-top">
          <div class="sidebar-brand">站巨者Ai图片</div>
          <div class="btn-new" :class="{ 'btn-disabled': messages.length === 0 }" @click="addSession">
            <svg t="1778119796155" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18867" width="20" height="20">
                <path d="M512 152.74c48.8 0 96.05 9.57 140.54 28.35 43.06 18.18 81.69 44.26 114.82 77.51 33.25 33.25 59.21 71.88 77.51 114.82 18.78 44.49 28.35 91.74 28.35 140.54s-9.57 96.05-28.35 140.54c-18.18 43.06-44.26 81.69-77.51 114.82-33.25 33.25-71.88 59.21-114.82 77.51-44.5 18.77-91.74 28.34-140.54 28.34s-96.05-9.57-140.54-28.35c-43.06-18.18-81.69-44.26-114.82-77.51-33.25-33.25-59.21-71.88-77.51-114.82-18.78-44.49-28.35-91.74-28.35-140.54s9.57-96.05 28.35-140.54c18.18-43.06 44.26-81.69 77.51-114.82 33.25-33.25 71.88-59.21 114.82-77.51 44.49-18.77 91.74-28.34 140.54-28.34m0-86.12c-247.11 0-447.33 200.22-447.33 447.33S264.89 961.29 512 961.29s447.33-200.22 447.33-447.33S759.11 66.62 512 66.62z" fill="#040000" p-id="18868"></path><path d="M510.81 726.23c-20.67 0-37.39-16.72-37.39-37.39V331.37c0-20.67 16.72-37.39 37.39-37.39s37.39 16.72 37.39 37.39v357.47c-0.01 20.67-16.73 37.39-37.39 37.39z" fill="#040000" p-id="18869"></path>
                <path d="M688.61 550.51H332.39c-20.67 0-37.39-16.72-37.39-37.39s16.72-37.39 37.39-37.39h356.22c20.67 0 37.39 16.72 37.39 37.39-0.01 20.67-16.73 37.39-37.39 37.39z" fill="#040000" p-id="18870"></path></svg>
            <span>新建</span>
          </div>
          <div class="session-list">
            <div class="session-history" v-if="sessions.length > 0">历史记录</div>
            <div
              v-for="(s, i) in sessions"
              :key="i"
              :class="['session-item', { active: activeIndex === i }]"
              @click="selectSession(i, s)"
            >
              <svg viewBox="0 0 24 24" width="15" height="15" class="sess-icon">
                <path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
              </svg>
              <span class="sess-title">{{ s.title }}</span>
            </div>
          </div>
        </div>
        <div class="sidebar-bottom">
          <!-- 未登录：注册/登录 -->
          <div v-if="!user" class="sidebar-auth">
            <!-- <button class="sidebar-auth-btn sidebar-register-btn" @click="handleAuth">注册</button> -->
            <button class="sidebar-auth-btn sidebar-login-btn" @click="handleAuth">登录</button>
          </div>
          <!-- 已登录：用户信息（无点击事件） -->
          <div v-else class="sidebar-user-info">
            <img :src="user.avatarurl || ''" class="sidebar-avatar" alt="" />
            <div class="sidebar-user-detail">
              <div class="sidebar-username">{{ user.nickname }}</div>
              <div class="sidebar-score">{{ user.score_balance }} 积分</div>
            </div>
          </div>
          <div class="btn-new" @click="clearSessions" v-if="sessions.length > 0">
            <img src="./img/clear_icon.png" class="sidebar-btn-icon" alt="" />
            <span>清除</span>
          </div>
          
          
          <!-- 已登录：退出登录 -->
          <div v-if="user" class="btn-new btn-logout" @click="handleLogout">
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path fill="currentColor" d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
            </svg>
            <span>退出登录</span>
          </div>
        </div>
      </aside>

      <!-- Main (9) -->
      <main class="gen-main" @click="closeAllDropdowns">
        <div class="main-center" :class="{ 'has-messages': messages.length > 0 }">
          <!-- 欢迎标题：无记录时显示 -->
          <h1 v-if="messages.length === 0" class="model-heading">站巨者Ai图片</h1>

          <!-- 聊天记录滚动区：有记录时显示 -->
          <div v-if="messages.length > 0" class="chat-scroll" ref="chatScroll" @scroll.passive="handleChatScroll">
            <div v-if="sessionLoadingMore" class="history-loading">加载中...</div>
            <div v-for="(msg, i) in messages" :key="i" class="msg-item">
              <p class="msg-prompt">{{ msg.prompt }}</p>
              <div class="msg-meta">
                <div class="msg-tags">
                  <span class="msg-tag">{{ msg.model }}</span>
                  <span class="msg-tag" v-if="msg.style">{{ msg.style }}</span>
                  <span class="msg-tag">2K</span>
                </div>
                <span class="msg-time">{{ msg.time }}</span>
              </div>
              <div v-if="msg.error" class="msg-error">生成失败，请重试</div>
              <template v-else>
                <div v-if="!msg.images.length" class="msg-loading">
                  <div class="loading-progress">
                    <div class="loading-fill" :style="{ width: (msg.progress || 0) + '%' }"></div>
                  </div>
                  <span class="loading-text">生成中 {{ msg.progress || 0 }}%</span>
                </div>
                <div v-else class="msg-images">
                  <!-- {{ msg }} -->
                  <img
                    v-for="(imgUrl, j) in msg.cover_images"
                    :key="j"
                    :src="imgUrl"
                    class="msg-img"
                    alt=""
                    @click="openLightbox(msg.images[j] || imgUrl)"
                  />
                </div>
              </template>
            </div>
          </div>

          <!-- Input Card -->
          <div class="input-card">
            <textarea
              class="gen-textarea"
              v-model="inputText"
              placeholder="尽输入您的图片描述，比如一幅美丽的山水画，夕阳下的海边。"
            ></textarea>
            <div class="input-bar">
              <div class="bar-left">
                <!-- Model Selector -->
                <div class="sel-btn model-sel" @click.stop="modelOpen = !modelOpen">
                  <span class="sel-text">{{ currentModel.label }}</span>
                  <svg viewBox="0 0 24 24" width="13" height="13" class="arrow-icon">
                    <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                  </svg>
                  <div class="drop-panel" v-show="modelOpen">
                    <div
                      v-for="m in models"
                      :key="m.value"
                      :class="['drop-item', { active: currentModel.value === m.value }]"
                      @click.stop="currentModel = m; modelOpen = false"
                    >{{ m.label }}</div>
                  </div>
                </div>

                <!-- Style Selector -->
                <div class="sel-btn param-sel" @click.stop="styleOpen = !styleOpen">
                  <svg viewBox="0 0 24 24" width="14" height="14" class="param-icon">
                    <path fill="currentColor" d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                  </svg>
                  <span class="sel-text">{{ currentStyle.label }}</span>
                  <svg viewBox="0 0 24 24" width="13" height="13" class="arrow-icon">
                    <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                  </svg>
                  <div class="drop-panel" v-show="styleOpen">
                    <div
                      v-for="s in styles"
                      :key="s.value"
                      :class="['drop-item', { active: currentStyle.value === s.value }]"
                      @click.stop="currentStyle = s; styleOpen = false"
                    >{{ s.label }}</div>
                  </div>
                </div>

                <!-- Size + Count Selector -->
                <div class="sel-btn param-sel" @click.stop="sizeOpen = !sizeOpen">
                  <svg viewBox="0 0 24 24" width="14" height="14" class="param-icon">
                    <path fill="currentColor" d="M21 15.61L19.59 17l-2.09-2.09L16 16.5V13h3.5l-1.42 1.42L21 15.61M10 3H8v2H6V3H4v6h6V3m6 9h-4v10h10V12h-6m2 8H14v-6h4v6M2 13v2h2v2H2v2h6v-6H2m2 4v-2h2v2H4M18 2l-6 6h4v4h4V8h4l-6-6z"/>
                  </svg>
                  <span class="sel-text">{{ currentSize.label }}</span>
                  <svg viewBox="0 0 24 24" width="13" height="13" class="arrow-icon">
                    <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                  </svg>
                  <div class="drop-panel size-drop" v-show="sizeOpen">
                    <div class="drop-section-title">尺寸</div>
                    <div class="drop-grid">
                      <div
                        v-for="sz in sizes"
                        :key="sz.value"
                        :class="['size-chip', { active: currentSize.value === sz.value }]"
                        @click.stop="currentSize = sz"
                      >{{ sz.label }}</div>
                    </div>
                    <div class="drop-divider"></div>
                    <!-- <div class="drop-section-title">数量</div>
                    <div class="drop-grid">
                      <div
                        v-for="ct in counts"
                        :key="ct.value"
                        :class="['size-chip', { active: currentCount.value === ct.value }]"
                        @click.stop="currentCount = ct"
                      >{{ ct.label }}</div>
                    </div> -->
                    <div class="drop-confirm">
                      <button class="confirm-btn" @click.stop="sizeOpen = false">确定</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bar-right">
                <button
                  :class="['send-btn', { active: inputText.trim() && !generating }]"
                  :disabled="generating"
                  @click.stop="generate"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16">
                    <path fill="currentColor" d="M2 21l21-9L2 3v7l15 2-15 2v7z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- 优秀作品 -->
          <featured-works
            v-if="messages.length === 0"
            :cate-id="101"
            @use-prompt="inputText = $event"
          />
        </div>
        <div class="ai-tips">内容由AI生成，请注意甄别</div>
      </main>
    </div>
    <!-- 灯箱弹层 -->
    <div v-if="lightbox.visible" class="lightbox-overlay" @click.self="closeLightbox">
      <div class="lightbox-wrap">
        <div class="lightbox-img-box">
          <img
            :src="lightbox.url"
            class="lightbox-img"
            :style="{ transform: `scale(${lightbox.scale}) rotate(${lightbox.rotation}deg)` }"
            alt=""
          />
        </div>
        <div class="lightbox-toolbar">
          <button class="lb-btn" title="放大" @click="lbZoomIn">
            <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2V7z"/></svg>
            <span>放大</span>
          </button>
          <button class="lb-btn" title="缩小" @click="lbZoomOut">
            <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"/></svg>
            <span>缩小</span>
          </button>
          <button class="lb-btn" title="旋转" @click="lbRotate">
            <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L9.95 21.4l-2.48.09zM12.05 0c-.23 0-.44.02-.66.03l2.66 2.56 2.48-.09C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zm-1.39 9.03c-1.65.59-2.73 2.3-2.43 4.12.33 2.01 2.21 3.37 4.22 3.04 1.65-.27 2.9-1.62 3.07-3.19H14c-.15.86-.82 1.57-1.72 1.72-1.19.2-2.31-.61-2.52-1.8-.2-1.17.6-2.29 1.77-2.51.51-.1 1.01-.01 1.43.23l-1.27 1.27 3.94.4-.4-3.94-1.27 1.27c-.72-.43-1.57-.64-2.3-.61z"/></svg>
            <span>旋转</span>
          </button>
          <button class="lb-btn" title="下载" @click="lbDownload">
            <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z"/></svg>
            <span>下载</span>
          </button>
          <button class="lb-btn lb-btn-close" title="关闭" @click="closeLightbox">
            <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
            <span>关闭</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeaturedWorks from '@/components/FeaturedWorks.vue';

const ALL_GALLERY = [
  { bg: 'linear-gradient(135deg, #f5e6c8 0%, #c8921a 100%)' },
  { bg: 'linear-gradient(135deg, #0d0d2b 0%, #2c2c6e 100%)' },
  { bg: 'linear-gradient(135deg, #ff6b6b 0%, #9b2eff 100%)' },
  { bg: 'linear-gradient(135deg, #050a1e 0%, #0a3a6b 50%, #2196F3 100%)' },
  { bg: 'linear-gradient(135deg, #051724 0%, #0d4a5c 50%, #00bcd4 100%)' },
  { bg: 'linear-gradient(135deg, #160a2e 0%, #4a148c 50%, #7b2ff7 100%)' },
  { bg: 'linear-gradient(135deg, #fce4ec 0%, #f48fb1 50%, #e91e63 100%)' },
  { bg: 'linear-gradient(135deg, #e0f2f1 0%, #80cbc4 50%, #009688 100%)' },
  { bg: 'linear-gradient(135deg, #fff8e1 0%, #ffca28 50%, #ff6f00 100%)' },
  { bg: 'linear-gradient(135deg, #e8f5e9 0%, #66bb6a 50%, #1b5e20 100%)' },
  { bg: 'linear-gradient(135deg, #e3f2fd 0%, #42a5f5 50%, #0d47a1 100%)' },
  { bg: 'linear-gradient(135deg, #fdf2f8 0%, #ec4899 50%, #7e22ce 100%)' },
];

export default {
  name: 'ImageGen',
  components: { FeaturedWorks },
  data() {
    return {
      inputText: '',
      sessions: [],
      activeIndex: -1,
      modelOpen: false,
      styleOpen: false,
      sizeOpen: false,
      currentModel: { value: 85, label: 'seedream4.5' },
      currentStyle: { value: 'none', label: '风格' },
      currentSize: { value: '1366x3200', label: '9:16' },
      currentCount: { value: '1', label: '1张' },
      models: [
        { value: 85, label: 'seedream4.5' }
      ],
      styles: [
        { value: 'none', label: '无风格' },
        { value: 'realistic', label: '写实' },
        { value: 'anime', label: '动漫' },
        { value: 'oilpaint', label: '油画' },
        { value: 'watercolor', label: '水彩' },
        { value: 'sketch', label: '素描' },
        { value: '3d', label: '3D渲染' },
        { value: 'cyberpunk', label: '赛博朋克' },
        { value: 'chinese', label: '中国风' },
      ],
      sizes: [
        { value: '1366x3200', label: '9:16' },
        { value: '2048x2048', label: '1:1' },
        { value: '2560x1440', label: '16:9' },
        { value: '1920x2560', label: '3:4' },
        { value: '2560x1920', label: '4:3' },
      ],
      counts: [
        { value: '1', label: '1张' },
        { value: '2', label: '2张' },
        { value: '4', label: '4张' },
      ],
      gallery: [],
      messages: [],
      historyId: 0,
      generating: false,
      pollingTimers: {},
      sessionPage: 1,
      sessionPageSize: 10,
      sessionHasMore: false,
      sessionLoadingMore: false,
      lightbox: {
        visible: false,
        url: '',
        scale: 1,
        rotation: 0,
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  created() {
    this.gallery = ALL_GALLERY.slice(0, 8);
    this.loadHistory();
  },
  beforeDestroy() {
    Object.values(this.pollingTimers).forEach(t => clearInterval(t));
  },
  methods: {
    handleAuth() {
      if (this.$showLogin) {
        this.$showLogin();
      }
    },
    handleLogout() {
      this.$logout();
    },
    loadHistory() {
      this.$http.get('/front/aipkai/algorithm/history/', {
        params: { cate_id: 101, page: 1, size: 10 },
      }).then(res => {
        if (res && res.status === 200 && res.data) {
          const list = res.data.item_list || [];
          this.sessions = list.map(item => ({
            id: item.id,
            title: this.extractPrompt(item.message).slice(0, 16) || '图片生成',
          }));
          if (this.sessions.length > 0) this.activeIndex = 0;
        }
      }).catch(() => {});
    },
    tryParseMessage(msg) {
      if (!msg) return {};
      try { return JSON.parse(msg); } catch (e) { return {}; }
    },
    extractPrompt(msg) {
      if (!msg) return '';
      try { return JSON.parse(msg).prompt || msg; } catch (e) { return msg; }
    },
    formatAddTime(ts) {
      if (!ts) return '';
      const d = typeof ts === 'number' ? new Date(ts * 1000) : new Date(ts);
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    buildMessageFromGroup(group) {
      const first = group[0];
      const inputJson = first.input_json || {};
      const done = group.length > 0 && group.every(task => task.progress === 100);
      const failed = group.some(task => task.status === 3);
      const avgProgress = group.length
        ? Math.floor(group.reduce((sum, task) => sum + (task.progress || 0), 0) / group.length)
        : 0;
      const images = [];
      const cover_images = [];
      if (done) {
        for (const task of group) {
          const out = task.output_json || {};
          if (Array.isArray(out.images)) {
            images.push(...out.images);
          } else if (out.url) {
            images.push(out.cdn_url || out.url);
            cover_images.push(out.cdn_cover_url || out.cover_url);
          }
        }
      }
      return {
        pk_group_id: first.pk_group_id,
        tempId: (!done && !failed) ? `h_${first.pk_group_id}` : null,
        prompt: inputJson.prompt || '',
        model: first.model_name || '',
        style: inputJson.style || '',
        ratio: inputJson.size || '',
        time: this.formatAddTime(first.add_time),
        images,
        cover_images,
        progress: done ? 100 : (failed ? 0 : avgProgress),
        error: failed,
      };
    },
    fetchSessionPage(historyId, page, options = {}) {
      const { prepend = false, scrollToBottom = false } = options;
      const scrollEl = this.$refs.chatScroll;
      const prevScrollHeight = prepend && scrollEl ? scrollEl.scrollHeight : 0;
      const prevScrollTop = prepend && scrollEl ? scrollEl.scrollTop : 0;

      return this.$http.get('/front/aipkai/algorithm/task/', {
        params: { history_id: historyId, page, size: this.sessionPageSize, status: 0 },
      }).then(res => {
        if (!res || !res.data) return;
        const rawGroups = res.data.item_list || [];
        const groups = rawGroups.slice().reverse();
        const nextMessages = groups.map(group => this.buildMessageFromGroup(group));

        this.messages = prepend ? [...nextMessages, ...this.messages] : nextMessages;
        this.sessionPage = page;
        this.sessionHasMore = rawGroups.length >= this.sessionPageSize;

        this.messages.forEach(msg => {
          if (msg.tempId && !this.pollingTimers[msg.tempId]) {
            this.pollTask(msg.pk_group_id, msg.tempId, historyId);
          }
        });

        this.$nextTick(() => {
          const el = this.$refs.chatScroll;
          if (!el) return;
          if (scrollToBottom) {
            el.scrollTop = el.scrollHeight;
            setTimeout(() => {
              if (this.$refs.chatScroll) this.$refs.chatScroll.scrollTop = this.$refs.chatScroll.scrollHeight;
            }, 300);
            setTimeout(() => {
              if (this.$refs.chatScroll) this.$refs.chatScroll.scrollTop = this.$refs.chatScroll.scrollHeight;
            }, 800);
            return;
          }
          if (prepend) {
            el.scrollTop = el.scrollHeight - prevScrollHeight + prevScrollTop;
          }
        });
      });
    },
    addSession() {
      if (this.messages.length === 0) return;
      Object.values(this.pollingTimers).forEach(t => clearInterval(t));
      this.pollingTimers = {};
      this.messages = [];
      this.historyId = 0;
      this.sessionPage = 1;
      this.sessionHasMore = false;
      this.sessionLoadingMore = false;
      this.activeIndex = -1;
    },
    clearSessions() {
      if (!this.user || !localStorage.getItem('token')) {
        this.$toast && this.$toast('请先登录');
        this.$showLogin();
        return;
      }
      if (this.sessions.length === 0) return;
      if (confirm('确定要清除所有记录？')) {
        this.$http.delete('/front/aipkai/algorithm/history/', {
          params: { cate_id: 101 },
        }).then(() => {
          this.sessions = [];
          this.messages = [];
          this.sessionPage = 1;
          this.sessionHasMore = false;
          this.sessionLoadingMore = false;
          this.activeIndex = -1;
        }).catch(() => {
          this.$toast && this.$toast('清除失败，请稍后重试');
        });
      }
    },
    closeAllDropdowns() {
      this.modelOpen = false;
      this.styleOpen = false;
      this.sizeOpen = false;
    },
    generate() {
      if (!this.user || !localStorage.getItem('token')) {
        this.$toast && this.$toast('请先登录');
        this.$showLogin();
        return;
      }
      this.generating = true;
      const prompt = this.inputText.trim();
      const pad = n => String(n).padStart(2, '0');
      const now = new Date();
      const timeStr = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
      const tempId = `t_${Date.now()}`;
      this.messages.push({
        tempId,
        pk_group_id: null,
        prompt,
        model: this.currentModel.label,
        style: this.currentStyle.value !== 'none' ? this.currentStyle.label : '',
        ratio: this.currentSize.label,
        time: timeStr,
        images: [],
        progress: 0,
        error: false,
      });
      this.inputText = '';
      this.$nextTick(() => {
        const el = this.$refs.chatScroll;
        if (el) el.scrollTop = el.scrollHeight;
      });
      this.$http.post('/front/aipkai/algorithm/task/', {
        model_ids: [this.currentModel.value],
        // parameters: { prompt, size: this.currentSize.value },
        parameters: {"prompt": prompt, "size": this.currentSize.value, "aspect_ratio": this.currentSize.value, "refer_images": [], "refer_cover_images": []},
        cate_id: 101,
        history_id: this.historyId,
        style_option_id: '',
        num: parseInt(this.currentCount.value) || 1,
        is_public: 0,
        parent_id: 0,
        tool_id: 0,
        timbre_id: 0,
        user_file_ids: [],
      }).then(res => {
       
        this.generating = false;
        if (res && res.data) {
          this.$fetchUserProfile();
          const { pk_group_id, history_id } = res.data;
          if (!this.historyId) {
            this.historyId = history_id;
            this.sessions.unshift({ id: history_id, title: prompt.slice(0, 16) });
            this.activeIndex = 0;
          }
          const msg = this.messages.find(m => m.tempId === tempId);
          if (msg) { msg.pk_group_id = pk_group_id; msg.progress = 0; }
          this.pollTask(pk_group_id, tempId, history_id);
        } else {
          this._removeTempMsg(tempId);
          let msg = res.message || '提交失败，请稍后重试'
          this.$toast && this.$toast(msg);
        }
      }).catch((err) => {
        this.generating = false;
        this._removeTempMsg(tempId);
        let msg = err.message || '提交失败，请稍后重试'
        this.$toast && this.$toast(msg);
      });
    },
    _removeTempMsg(tempId) {
      const idx = this.messages.findIndex(m => m.tempId === tempId);
      if (idx !== -1) this.messages.splice(idx, 1);
    },
    pollTask(pk_group_id, tempId, historyId) {
      const timer = setInterval(() => {
        this.$http.get('/front/aipkai/algorithm/task/', {
          params: { history_id: historyId, page: 1, status: 0 },
        }).then(res => {
          if (!res || !res.data) return;
          const groups = res.data.item_list || [];
          const group = groups.find(g => g[0] && g[0].pk_group_id === pk_group_id);
          if (!group) return;
          const first = group[0];
          const msg = this.messages.find(m => m.tempId === tempId);
          if (!msg) { clearInterval(timer); delete this.pollingTimers[tempId]; return; }
          msg.progress = first.progress || 0;
          if (first.progress === 100) {
            const images = [];
            const cover_images = [];
            for (const task of group) {
              const out = task.output_json || {};
              if (Array.isArray(out.images)) images.push(...out.images);
              else if (out.url) {
                images.push(out.cdn_url || out.url); 
                cover_images.push(out.cdn_cover_url || out.cover_url);
              } 
            }
            msg.images = images;
            msg.cover_images = cover_images;
            clearInterval(timer);
            delete this.pollingTimers[tempId];
            this.$nextTick(() => {
              const el = this.$refs.chatScroll;
              if (el) el.scrollTop = el.scrollHeight;
            });
          } else if (first.status === 3) {
            msg.error = true;
            msg.progress = 0;
            clearInterval(timer);
            delete this.pollingTimers[tempId];
          }
        }).catch(() => {});
      }, 3000);
      this.pollingTimers[tempId] = timer;
    },
    selectSession(index, session) {
      // 切换 session 时先清除旧的轮询
      Object.values(this.pollingTimers).forEach(t => clearInterval(t));
      this.pollingTimers = {};
      this.activeIndex = index;
      if (session.id) this.loadSession(session.id);
    },
    loadSession(historyId) {
      this.historyId = historyId;
      this.messages = [];
      this.sessionPage = 1;
      this.sessionHasMore = false;
      this.sessionLoadingMore = false;
      this.fetchSessionPage(historyId, 1, { scrollToBottom: true }).catch(() => {});
    },
    handleChatScroll() {
      const el = this.$refs.chatScroll;
      if (!el || this.sessionLoadingMore || !this.sessionHasMore || !this.historyId) return;
      if (el.scrollTop > 80) return;
      this.sessionLoadingMore = true;
      this.fetchSessionPage(this.historyId, this.sessionPage + 1, { prepend: true })
        .catch(() => {
          this.$toast && this.$toast('历史记录加载失败，请稍后重试');
        })
        .finally(() => {
          this.sessionLoadingMore = false;
        });
    },
    shuffleGallery() {
      const shuffled = [...ALL_GALLERY].sort(() => Math.random() - 0.5);
      this.gallery = shuffled.slice(0, 8);
    },
    openLightbox(url) {
      this.lightbox = { visible: true, url, scale: 1, rotation: 0 };
    },
    closeLightbox() {
      this.lightbox.visible = false;
    },
    lbZoomIn() {
      this.lightbox.scale = Math.min(+(this.lightbox.scale + 0.25).toFixed(2), 4);
    },
    lbZoomOut() {
      this.lightbox.scale = Math.max(+(this.lightbox.scale - 0.25).toFixed(2), 0.25);
    },
    lbRotate() {
      this.lightbox.rotation = (this.lightbox.rotation + 90) % 360;
    },
    lbDownload() {
      const a = document.createElement('a');
      a.href = this.lightbox.url;
      a.download = 'image.jpg';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.ai-tips{
  text-align: center;
  color: #CFCFCF
}
.session-history{
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  // color: #E5E7EB;
  border-bottom: 1px solid #E5E7EB;
}
.gen-page {
  height: 100vh;
  display: flex;
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', sans-serif;
  overflow: hidden;

  /* ─── 左右布局容器 ─── */
  .gen-layout {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  /* ══════════════════════════════
     侧栏  flex: 1 (约 10%)
  ══════════════════════════════ */
  .gen-sidebar {
    flex: 1.5;
    min-width: 0;
    border-right: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #F9FBFC;
    overflow: hidden;

    .sidebar-top {
      display: flex;
      flex-direction: column;
      padding: 16px 10px 8px;
      gap: 8px;
      overflow: hidden;
    }

    /* 侧栏品牌标题 */
    .sidebar-brand {
      font-size: 20px;
      font-weight: 600;
      font-style: italic;
      color: #111827;
      padding: 6px 4px 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    //   border-bottom: 1px solid #f3f4f6;
    }

    /* 新建 / 清除 / 联系客服 — 统一按钮样式 */
    .btn-new {
      display: flex;
      align-items: center;
      gap: 7px;
      padding: 8px 12px;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      background-color: #fff;
      cursor: pointer;
      font-size: 13px;
      font-weight: 600;
      color: #000;
      user-select: none;
      transition: background 0.15s;
      white-space: nowrap;
      overflow: hidden;

      &:hover { background: #f9fafb; }

      &.btn-disabled {
        opacity: 0.4;
        cursor: not-allowed;
        &:hover { background: #fff; }
      }
    }
    
    .sidebar-btn-icon {
        width: 20px;
        height: 20px;
        object-fit: contain;
        flex-shrink: 0;
        filter: brightness(0);
      }

    .session-item {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 7px 8px;
      border-radius: 7px;
      cursor: pointer;
      font-size: 12px;
      color: #6b7280;
      transition: background 0.15s;

      &:hover { background: #f9fafb; }
      &.active { background: #f3f4f6; color: #111827; }

      .sess-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .sidebar-bottom {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 10px 10px 14px;

      .sidebar-auth {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .sidebar-auth-btn {
          width: 100%;
          height: 34px;
          font-size: 13px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 500;
          transition: opacity 0.15s;
        }

        .sidebar-register-btn {
          color: #111827;
          background: #fff;
          border: 1px solid #e5e7eb;
          &:hover { background: #f9fafb; }
        }

        .sidebar-login-btn {
          color: #fff;
          background: #111827;
          border: none;
          &:hover { opacity: 0.85; }
        }
      }

      .sidebar-user-info {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px;
        border-radius: 8px;
        background: #f3f4f6;

        .sidebar-avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
          background: #e5e7eb;
          flex-shrink: 0;
        }

        .sidebar-user-detail {
          flex: 1;
          min-width: 0;

          .sidebar-username {
            font-size: 13px;
            font-weight: 600;
            color: #111827;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .sidebar-score {
            font-size: 11px;
            color: #6b7280;
            margin-top: 2px;
          }
        }
      }

      .btn-logout {
        color: #ef4444;
        svg { flex-shrink: 0; }
        &:hover { background: #fff5f5; color: #ef4444; }
      }
    }
  }

  /* ══════════════════════════════
     主内容区  flex: 9 (约 90%)
  ══════════════════════════════ */
  .gen-main {
    flex: 8;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    /* 顶部栏：注册/登录按钮靠右 */
    .main-topbar {
      flex-shrink: 0;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 24px;

      .header-auth {
        display: flex;
        gap: 8px;

        .btn-register {
          height: 34px;
          padding: 0 22px;
          font-size: 14px;
          color: #111827;
          background: #fff;
          border: 1px solid #111827;
          border-radius: 6px;
          cursor: pointer;
          transition: opacity 0.15s;
          &:hover { opacity: 0.75; }
        }

        .btn-login {
          height: 34px;
          padding: 0 22px;
          font-size: 14px;
          color: #fff;
          background: #111827;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: opacity 0.15s;
          &:hover { opacity: 0.8; }
        }
      }

      .user-info-bar {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        padding: 4px 10px 4px 4px;
        border-radius: 8px;
        transition: background 0.15s;
        user-select: none;

        &:hover { background: #f3f4f6; }

        .user-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          object-fit: cover;
          background: #e5e7eb;
          flex-shrink: 0;
        }

        .user-name {
          font-size: 13px;
          font-weight: 500;
          color: #111827;
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .user-score {
          font-size: 12px;
          color: #6b7280;
          white-space: nowrap;
        }

        .arrow-icon { color: #9ca3af; flex-shrink: 0; }

        .user-drop {
          position: absolute;
          top: calc(100% + 6px);
          right: 0;
          min-width: 120px;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.1);
          z-index: 300;
          padding: 4px 0;

          .user-drop-item {
            padding: 9px 16px;
            font-size: 13px;
            color: #ef4444;
            cursor: pointer;
            transition: background 0.12s;
            &:hover { background: #fff5f5; }
          }
        }
      }
    }

    /* 居中内容区 */
    .main-center {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 32px 24px;

      .model-heading {
        width: 100%;
        max-width: 780px;
        text-align: center;
        font-style: italic;
        font-size: 50px;
        font-weight: 700;
        color: #111827;
        margin: 0 0 24px;
        letter-spacing: 0.02em;
      }

      /* ─── 输入卡片 ─── */
      .input-card {
        width: 100%;
        max-width: 1000px;
        border: 1px solid #e5e7eb;
        border-radius: 5px;
        background: #fff;
        overflow: visible;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

        .gen-textarea {
          display: block;
          width: 100%;
          min-height: 110px;
          padding: 18px 18px 10px;
          border: none;
          outline: none;
          resize: none;
          font-size: 14px;
          line-height: 1.6;
          color: #374151;
          box-sizing: border-box;
          font-family: inherit;
          border-radius: 14px 14px 0 0;

          &::placeholder { color: #9ca3af; }
        }

        .input-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 14px;
          border-top: 1px solid #f3f4f6;

          .bar-left {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;

            .sel-btn {
              position: relative;
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 5px 10px;
              border: 1px solid #e5e7eb;
              border-radius: 7px;
              cursor: pointer;
              font-size: 13px;
              color: #374151;
              background: #fff;
              user-select: none;
              transition: background 0.15s;

              &:hover { background: #f9fafb; }

              .sel-text { white-space: nowrap; }
              .arrow-icon { color: #9ca3af; flex-shrink: 0; }
              .param-icon { color: #6b7280; flex-shrink: 0; }

              .drop-panel {
                position: absolute;
                bottom: calc(100% + 6px);
                left: 0;
                min-width: 140px;
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 10px;
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
                z-index: 200;
                padding: 4px 0;

                .drop-item {
                  padding: 9px 14px;
                  font-size: 13px;
                  color: #374151;
                  cursor: pointer;
                  transition: background 0.12s;

                  &:hover { background: #f9fafb; }
                  &.active { color: #2563eb; font-weight: 500; }
                }

                &.size-drop {
                  padding: 12px;
                  min-width: 220px;

                  .drop-section-title {
                    font-size: 12px;
                    color: #9ca3af;
                    margin-bottom: 8px;
                  }

                  .drop-grid {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 6px;
                    margin-bottom: 4px;

                    .size-chip {
                      padding: 4px 12px;
                      border: 1px solid #e5e7eb;
                      border-radius: 6px;
                      font-size: 13px;
                      color: #374151;
                      cursor: pointer;
                      transition: all 0.12s;

                      &:hover { background: #f9fafb; }
                      &.active {
                        border-color: #2563eb;
                        color: #2563eb;
                        background: #eff6ff;
                      }
                    }
                  }

                  .drop-divider {
                    height: 1px;
                    background: #f3f4f6;
                    margin: 10px 0;
                  }

                  .drop-confirm {
                    margin-top: 10px;
                    text-align: right;

                    .confirm-btn {
                      padding: 5px 16px;
                      background: #111827;
                      color: #fff;
                      border: none;
                      border-radius: 6px;
                      font-size: 13px;
                      cursor: pointer;
                      &:hover { opacity: 0.85; }
                    }
                  }
                }
              }
            }
          }

          .bar-right {
            .send-btn {
              width: 34px;
              height: 34px;
              border-radius: 50%;
              border: none;
              background: #d1d5db;
              color: #fff;
              cursor: default;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: background 0.2s;
              flex-shrink: 0;

              &.active {
                background: #111827;
                cursor: pointer;
                &:hover { background: #374151; }
              }

              svg { display: block; }
            }
          }
        }
      }

      /* ─── 优秀作品画廊 ─── */
      .gallery-area {
        width: 100%;
        max-width: 1000px;
        margin-top: 18px;
        border: 1px solid #e5e7eb;
        border-radius: 5px;
        overflow: hidden;
        padding: 15px;

        .gallery-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          .gallery-label {
            font-size: 13px;
            color: #9ca3af;
          }

          .gallery-refresh {
            font-size: 13px;
            color: #9ca3af;
            cursor: pointer;
            transition: color 0.15s;
            &:hover { color: #374151; }
          }
        }

        .gallery-row {
          display: flex;
          gap: 8px;

          .gallery-cell {
            flex: 1;
            height: 88px;
            border-radius: 10px;
            overflow: hidden;
            cursor: pointer;
            transition: transform 0.15s, box-shadow 0.15s;

            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
            }
          }
        }
      }

      /* ─── 有消息时：覆盖布局行为 ─── */
      &.has-messages {
        justify-content: flex-start;
        overflow-y: hidden;
        padding: 0 24px 20px;
      }

      /* ─── 聊天滚动区 ─── */
      .chat-scroll {
        flex: 1;
        overflow-y: auto;
        width: 100%;
        max-width: 1000px;
        padding: 20px 0 8px;
        scrollbar-width: none;
        &::-webkit-scrollbar { display: none; }

        .history-loading {
          text-align: center;
          font-size: 12px;
          color: #9ca3af;
          padding: 4px 0 16px;
        }

        .msg-item {
          margin-bottom: 40px;
          padding-bottom: 80px;
          border-bottom: 1px solid #e5e7eb;

          .msg-prompt {
            font-size: 14px;
            color: #374151;
            line-height: 1.75;
            margin: 0 0 10px;
            word-break: break-all;
            white-space: pre-wrap;
          }

          .msg-meta {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 14px;
            padding: 10px 0;

            .msg-tags {
              display: flex;
              gap: 6px;
            }

            .msg-tag {
              padding: 2px 10px;
              background: #f3f4f6;
              border-radius: 4px;
              font-size: 12px;
              color: #6b7280;
            }

            .msg-time {
              font-size: 12px;
              color: #9ca3af;
            }
          }

          .msg-loading {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 16px 0;

            .loading-progress {
              width: 100%;
              max-width: 400px;
              height: 6px;
              background: #f3f4f6;
              border-radius: 3px;
              overflow: hidden;

              .loading-fill {
                height: 100%;
                background: linear-gradient(90deg, #6366f1, #a855f7);
                border-radius: 3px;
                transition: width 0.5s ease;
              }
            }

            .loading-text {
              font-size: 13px;
              color: #9ca3af;
            }
          }

          .msg-error {
            font-size: 13px;
            color: #ef4444;
            padding: 12px 0;
          }

          .msg-images {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;

            .msg-img {
              max-width: 260px;
              width: auto;
              height: auto;
              max-height: 480px;
              border-radius: 8px;
              object-fit: cover;
              display: block;
              cursor: zoom-in;
              transition: opacity 0.15s;
              &:hover { opacity: 0.85; }
            }
          }
        }
      }
    }
  }
}

/* ══════════════════════════════
   灯箱弹层
══════════════════════════════ */
.lightbox-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 90vw;
  max-height: 90vh;
}

.lightbox-img-box {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 80vw;
  max-height: 78vh;

  .lightbox-img {
    max-width: 80vw;
    max-height: 78vh;
    object-fit: contain;
    border-radius: 6px;
    transition: transform 0.3s ease;
    display: block;
  }
}

.lightbox-toolbar {
  display: flex;
  gap: 10px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 40px;
  padding: 8px 20px;

  .lb-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    padding: 6px 12px;
    background: transparent;
    border: none;
    color: #fff;
    cursor: pointer;
    border-radius: 8px;
    font-size: 11px;
    transition: background 0.15s;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }

    svg { flex-shrink: 0; }
  }

  .lb-btn-close {
    color: #f87171;
    &:hover { background: rgba(248, 113, 113, 0.15); }
  }
}
</style>
